import Panel from "./panel/index.js";
import { ButtonTool, ButtonSubmit, ButtonPlayBack, ButtonPlaySpeed } from "./button/index.js";
import Toolbar from "./toolbar/index.js";
import { LayoutBody, LayoutContent, Layout, LayoutTabs, LayoutSlider } from "./layout/index.js";
import EvaluateScore from "./evaluateScore/index"; // 练习统计
import AiSuggestScore from "./aiSuggestScore/index.vue"; // 人工批改详情的 AI 建议评分

export default {
  install(Vue) {
    Vue.component("Panel", Panel);
    Vue.component("ButtonTool", ButtonTool);
    Vue.component("ButtonSubmit", ButtonSubmit);
    Vue.component("EvaluateScore", EvaluateScore);
    Vue.component("AiSuggestScore", AiSuggestScore);
    Vue.component("ButtonPlayBack", ButtonPlayBack);
    Vue.component("ButtonPlaySpeed", ButtonPlaySpeed);
    Vue.component("Toolbar", Toolbar);
    Vue.component("LayoutBody", LayoutBody);
    Vue.component("LayoutContent", LayoutContent);
    Vue.component("LayoutSlider", LayoutSlider);
    Vue.component("LayoutTabs", LayoutTabs);
    Vue.component("Layout", Layout);
  },
};
